export default {
  hero_label: 'SERVICE',
  hero_title_en: 'AIX Training',
  hero_title_ja: 'AIX トレーニング',
  hero_desc: 'AIリテラシーの底上げから専門AI人材の育成まで、\n貴社の組織・業種に合わせたオーダーメイドプログラムを提供します。',
  overview_label: 'OVERVIEW',
  overview_title: 'サービス概要',
  overview_desc: 'AIX Trainingは、AIリテラシーの底上げから社内AI推進人材の育成まで、組織全体のAI活用レベルを引き上げるための人材育成サービスです。\n\n単なる知識提供にとどまらず、実際の業務に直結した実践トレーニングを重視。貴社の業種・組織規模・習熟度に合わせた完全オーダーメイドのプログラムで、現場で本当に使えるAI人材を育成します。',
  programs_label: 'PROGRAMS',
  programs_title: 'プログラムタイプ',
  program_1_label: '全社員向け',
  program_1_desc: 'AIリテラシー基礎研修',
  program_1_detail: 'AIの基本概念・生成AIツールの基礎・業務活用の第一歩を学ぶ入門研修',
  program_2_label: 'マネージャー向け',
  program_2_desc: 'AI経営・推進リーダー研修',
  program_2_detail: 'AI投資の意思決定・チームのAI活用推進・変革マネジメントに特化した研修',
  program_3_label: 'エンジニア向け',
  program_3_desc: 'AI開発・実装実践研修',
  program_3_detail: 'LLM API活用・RAG構築・AIエージェント開発など実装に直結するハンズオン研修',
  program_4_label: 'ビジネス職向け',
  program_4_desc: '生成AI業務活用研修',
  program_4_detail: '提案書・報告書・分析レポートなど日常業務での生成AI活用スキルを磨く実践研修',
  services_label: 'SERVICES',
  services_title: '主なサービス内容',
  service_1_title: 'AIリテラシー研修',
  service_1_desc: 'AI基礎知識からビジネス活用の実践まで、全社員を対象としたAIリテラシー研修を提供。AIを正しく理解し、日常業務で活かせる土台を築きます。',
  service_2_title: 'AI活用実践トレーニング',
  service_2_desc: '職種・業務内容に応じたロール別の実践トレーニングを実施。生成AI・データ分析ツールなど、実務で即戦力となるAIスキルを習得します。',
  service_3_title: 'AI人材育成プログラム',
  service_3_desc: '社内AI推進リーダー・AI活用スペシャリストを育成するための体系的なプログラム。組織内のAI活用を牽引できる人材を継続的に輩出します。',
  service_4_title: 'オーダーメイド研修設計',
  service_4_desc: '業種・組織規模・AI活用レベルに合わせた完全カスタマイズの研修プログラムを設計。現場で本当に使える知識とスキルの習得にフォーカスします。',
  challenges_label: 'CHALLENGES',
  challenges_title: 'こんな課題を解決します',
  challenge_1: '社員のAIリテラシーが低く、AI活用が進まない',
  challenge_2: 'AI活用のノウハウが一部の担当者に偏っている',
  challenge_3: '研修を実施したが現場での実践につながっていない',
  challenge_4: '部署・役職によってAI活用レベルに大きな差がある',
  challenge_5: '社内でAIを推進できる人材が育っていない',
  challenge_6: '自社の業種・業務に特化したAI研修が見つからない',
  reasons_label: 'WHY AIX JAPAN',
  reasons_title: 'AIX JAPANが選ばれる理由',
  reason_1_title: '完全オーダーメイドで設計',
  reason_1_desc: 'ヒアリングを徹底し、業種・役職・現在のAIレベルに合わせた完全カスタムプログラムを設計。既製品の研修では得られない実践力を提供します。',
  reason_2_title: '業種特化の豊富な知見',
  reason_2_desc: '製造・金融・小売・医療・ITなど多様な業種での研修実績をもとに、その業界の言語・課題に沿った具体的なAI活用事例で指導します。',
  reason_3_title: '実践重視のプログラム設計',
  reason_3_desc: '知識詰め込み型の研修ではなく、ハンズオン・ワークショップ・業務シミュレーションを組み合わせ、終わった翌日から使えるスキルを習得。',
  reason_4_title: '定着まで長期サポート',
  reason_4_desc: '研修後のフォローアップ・職場での実践支援・習熟度テストまで含めた継続サポートで、学びを確実に成果へとつなげます。',
  flow_label: 'FLOW',
  flow_title: '研修導入の流れ',
  flow_intro: 'アセスメントから研修後の定着支援まで、各ステップの作業内容と成果物を明確にして進めます。期間は対象人数・実施形式により変動するため、あくまで目安です。',
  flow_steps: [
    {
      no: '01',
      icon: 'ri-survey-line',
      title: '現状アセスメント',
      note: '初回相談無料',
      duration: '約1〜2週間',
      activities: [
        '社員のAIリテラシーレベル調査（アンケート等）',
        '業務課題・育成目標のヒアリングと対象者構成の整理',
      ],
      deliverables: ['アセスメント結果サマリ', '育成優先事項の整理'],
      clientAsks: ['対象者アンケートへのご回答', '育成目標のすり合わせ'],
    },
    {
      no: '02',
      icon: 'ri-book-open-line',
      title: 'プログラム設計',
      duration: '約2〜3週間',
      activities: [
        '業種・役職・習熟度に合わせたカリキュラム設計',
        '教材・演習の業務特化カスタマイズ、実施形式（対面／オンライン）の設計',
      ],
      deliverables: ['研修カリキュラム', '教材一式'],
      clientAsks: ['演習の題材となる業務資料のご提供', '実施日程の調整'],
    },
    {
      no: '03',
      icon: 'ri-presentation-line',
      title: '研修・トレーニング実施',
      duration: '半日×数回〜（設計による）',
      activities: [
        '座学・ハンズオン・ワークショップを組み合わせた研修の実施',
        '実業務を題材にした演習と理解度の確認',
      ],
      deliverables: ['実施レポート', '受講者の理解度サマリ'],
      clientAsks: ['受講時間の確保', '演習用の実業務題材のご提供'],
    },
    {
      no: '04',
      icon: 'ri-line-chart-line',
      title: '効果測定・継続支援',
      duration: '研修後1〜3ヶ月',
      activities: [
        '習熟度・業務変化の測定とフォローアップ研修',
        '社内AI推進リーダーの継続支援',
      ],
      deliverables: ['効果測定レポート', '次期育成プランのご提案'],
      clientAsks: ['実践状況のご共有', 'フォローアップ日程の調整'],
    },
  ],
};